import React, { useState, useEffect } from 'react'
import Texty from 'rc-texty';
import { Row, Col } from 'antd'
import './index.scss'
import Http from "@/utils/http";
import { useNavigate } from "react-router-dom";

export default function TopInfo(props) {
	const { imgBg, title, info1, info2, styleSelf } = props;
	const navigate = useNavigate()

	const [info, setInfo] = useState({});
	const [info3, setInfo3] = useState([])

	const [imgBG, setImgBG] = useState('')

	useEffect(() => {
		getNextM();
		getInfo();
	}, [title]);
	const getNextM = async () => {

		let res = await Http.to.items('menu_new').readByQuery({
			sort: ['id'],
		});
		let showdata = {};
		res.data?.nextmenu.forEach((item) => {
			if (item.title === title) {
				showdata = item;
			}
			item?.nextmenu.forEach((item2) => {
				if (item2.title === title) {
					showdata = item2;
				}
			})
		})
		showdata?.img?.split('"')?.forEach((item) => {

			if (item?.indexOf('http') !== -1 || item?.indexOf('assets') !== -1) {
				setImgBG(item);


			}
		})
		setInfo(showdata);
		console.log(res.data);
		console.log(showdata);

	}
	const toPage = (address, routerName) => {
		if (address.indexOf('http') !== -1) {
			window.open(address);
			return
		}
		navigate('/' + address);
	}
	const getInfo = async () => {
		let res = await Http.to.items('SolutionPage').readByQuery({
			sort: ['id'],
		});
		setInfo3(res.data);
		console.log(res.data);

	}
	return (
		<div className='top_info'>
			<Row>
				<Col span={24}>
					<div className="img_main"
						style={{
							backgroundColor: styleSelf?.bgColor ?? '',
							backgroundAttachment: styleSelf?.bgColor ? 'scroll' : 'fixed',
							backgroundImage: `url(${imgBG})`,
							paddingBottom: title === 'Solution' ? '20vh' : '0px'

						}}
					>
						<span className='titel'>
							<Texty interval={150} delay={500}>
								{
									info?.titletop
										? info.titletop.replace(/\s/g, (match) => {
											return String.fromCharCode(160);
										})
										: ''
								}
							</Texty>
						</span>
						<span>
							<Texty type="swing">{info?.info1}</Texty>
						</span>
						<span>
							<Texty type="swing">{info?.info2}</Texty>
						</span>
						<div className='bottom_direction'></div>
					</div>
				</Col>
			</Row >
			{
				title === 'Solution' && <div className='bottom_nav' >
					<Row align='middle' justify='center' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
						{info3.length !== 0 && info3.map((item) => {
							return <Col　>
								<div className='nav_box' onClick={() => {
									toPage('SolutionPage/'+item?.id)
								}}>
									<div className='bottom_direction'></div>
									<div className='title'>{

										item.title
									}</div>
									<div className='infoimg'>
									<div className='info'>
										{
											item.content
										}
										
										</div>
										<div>
											 <img src={`/assets/${item.imgsmall}`} ></img>
										</div>
									</div>
								</div>
							</Col>
						})}

					</Row>
				</div>
			}
		</div>
	)
}